import { ExternalCollectionNoticeState } from './collection-notice/collection-notice.state';
import { ExternalPaymentState } from './external-payments/external-payments.state';
import { ExternalFiscalRegimesState } from './fiscal-regime/fiscal-regime.state';
import { ExternalSessionState } from './session/session.state';

export * from './external-payments/external-payments.state';
export * from './fiscal-regime/fiscal-regime.state';
export * from './session/session.state';

export const ExternalStates = [
  ExternalPaymentState,
  ExternalFiscalRegimesState,
  ExternalCollectionNoticeState,
  ExternalSessionState,
];
